import { useState } from 'react'
// import { FileAudio } from 'lucide-react'
// import { useSnapshot } from 'valtio'
import { Upload } from 'antd'

import useInputUpload from '@/hooks/useInputUpload'
import ActionIcon from './ActionIcon'
const Icon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6746 17.5409C11.8383 17.8375 10.938 17.9989 10 17.9989C5.58172 17.9989 2 14.4172 2 9.9989C2 5.58062 5.58172 1.9989 10 1.9989C14.4183 1.9989 18 5.58062 18 9.9989C18 10.5776 17.9386 11.1419 17.8218 11.6857"
      stroke="#1C1F23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6665 13.7489C16.6665 13.3347 16.3307 12.9989 15.9165 12.9989C15.5023 12.9989 15.1665 13.3347 15.1665 13.7489V14.6656H14.25C13.8358 14.6656 13.5 15.0014 13.5 15.4156C13.5 15.8299 13.8358 16.1656 14.25 16.1656H15.1665V17.0822C15.1665 17.4964 15.5023 17.8322 15.9165 17.8322C16.3307 17.8322 16.6665 17.4964 16.6665 17.0822V16.1656H17.5833C17.9975 16.1656 18.3333 15.8299 18.3333 15.4156C18.3333 15.0014 17.9975 14.6656 17.5833 14.6656H16.6665V13.7489Z"
      fill="#0077FA"
    />
    <path
      d="M9.5 12.9989C10.3284 12.9989 11 12.3273 11 11.4989C11 10.6705 10.3284 9.9989 9.5 9.9989C8.67157 9.9989 8 10.6705 8 11.4989C8 12.3273 8.67157 12.9989 9.5 12.9989Z"
      stroke="#1C1F23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 11.4989V4.9989"
      stroke="#1C1F23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
const AudioUpload = () => {
  const { uploadLoading, beforeUploadAudio } = useInputUpload()

  return (
    <Upload
      accept="audio/*"
      beforeUpload={beforeUploadAudio}
      maxCount={1}
      showUploadList={false}
    >
      <ActionIcon
        title="支持mp3、wav、pcm等音频格式，一次最多上传一个文件，单次不超过20M"
        Icon={Icon}
        loading={uploadLoading}
      />
    </Upload>
  )
}

export default AudioUpload
